import {Component} from '@angular/core';
import {HttpEventType} from '@angular/common/http';
import {ResourcesService} from '../../services/resources.service';
import {saveAs} from 'file-saver';

import {BreadcrumbComponent} from "../../components/common/breadcrumb/breadcrumb.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
    selector: 'app-help',
    imports: [
    BreadcrumbComponent,
    FaIconComponent
],
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.css']
})
export class HelpComponent {

  constructor(private resourcesService: ResourcesService) {
  }

  downloadFile(): void {
    this.resourcesService.downloadDocumentation().subscribe(data => {
      if (data.type === HttpEventType.Response) {
        saveAs(data.body, 'Documentation Portail.pdf');
      }
    });
  }
}
